import { TextArea } from '@ui-components/neo.tax';
import React from 'react';

import { TextAreaFormType } from './forms.types';

export const TextAreaForm = ({ form }: { form: TextAreaFormType }): React.ReactElement | null => (
  <TextArea
    value={form.value || ''}
    placeholder={form.placeholder || ''}
    type="text"
    name={form.key}
    rows={form.rows}
    disabled={form.disabled}
    id={form.id}
    textAreaButton={form.textAreaButton}
    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
      form.onChange(event.target.value);
    }}
  />
);
